import type { UUID } from 'crypto';
import { map } from 'lodash';

import { OptionType } from '@/components/base/Select';

class CommonService {
    /**
     * Generates a random UUID using the browser's crypto.randomUUID() API if available,
     * or falls back to a custom implementation for older browsers or localhost development.
     *
     * @returns A random UUID string
     */
    generateUUID(): UUID {
        // Check if crypto.randomUUID is available
        if (typeof crypto !== 'undefined' && crypto.randomUUID) {
            return crypto.randomUUID() as UUID;
        }

        // Fallback for localhost development because crypto API is not available in unsecure contexts (Will not be used in staging or production)
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            const r = (Math.random() * 16) | 0;
            const v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        }) as UUID;
    }

    formatLabelOptions = (list: { label: string; id: string }[]): OptionType[] =>
        map(list, (el) => ({ label: el.label, value: el.label, id: el.id })) ?? [];
}

const commonService = new CommonService();

export { commonService as CommonService };
